<template>
    <section>
        <section class="gz-input__duplicate-block">
            <section
                v-if="itemsComputed.value.length" 
                class="gz-input__duplicate-block_items">
                <div 
                    v-for="(item, index) in itemsComputed.value" 
                    :key="index"
                    class="gz-input__duplicate-block_item"
                >
                    <div class="gz-input__duplicate-block_item__container">
                        <div class="gz-input__duplicate-block_number">
                            <span>{{index+1}}</span>
                        </div>
                        <!-- Если есть тип -->
                        <div>
                            <span
                                v-if="types.length"
                                class="gz-input__duplicate-block_item__title">
                                <strong>Тип:</strong> {{ item.type.name }}
                            </span>
                        </div>

                        <div>
                            <span class="gz-input__duplicate-block_item__title"><strong>Название:</strong> {{ item.descr }}</span>
                        </div>
                    </div>
                    <span 
                        class="icon-cross gz-input__duplicate-block_item__icon"
                        @click="items.value.splice(index, 1)"
                    ></span>
                </div>
            </section>
            
            <gz-input-container
                :label="descr"
            >
                <GZ-TextInput
                    ref="Input"
                    class="gz-text-input_dark"
                    @value="items.bufferDescr = $event"
                />
            </gz-input-container>
            
            <!-- Если есть типы - показывать выпадающий список -->
            <!-- Создание объекта с пустыми значениями при выборе типа, обеспечивает реактивность в инпуте с названием типа  -->
            <gz-select-container
                v-if="types.length"
                :label="type"
                class="gz-input-container_default gz-input-container_dark"
                :dataList="types"
                @selectedItem="
                    items.buffer = {value: '', name: ''}, 
                    items.buffer.value = $event.value, 
                    items.buffer.name = $event.name"   
            >
                <GZ-TextInput
                    :importedData="items.buffer.name"
                    :selectType="true"
                    class="gz-text-input_dark"
                    :readonly="true"
                />
            </gz-select-container>
        </section>
        
        <!-- Если есть типы - выпадающий список -->
        <GZ-BaseButton
            v-if="types.length" 
            class="gz-button gz-button_default gz-button_small"
            icon="icon-plus"
            style="margin-bottom: 20px; margin-left: auto"
            value="добавить"
            @click="addWithTypes()"
        />
        <!-- Если есть только строковое значение -->
        <GZ-BaseButton 
            v-else
            class="gz-button gz-button_default gz-button_small"
            icon="icon-plus"
            style="margin-bottom: 20px; margin-left: auto"
            value="добавить"
            @click="addWithoutTypes()"
        />
    </section>
</template>

<script>
export default {
    name: 'InputDublicateBlock',

    props: {
        items: {
            type: Object,
            default: () => ({})
        },
        type: {
            type: String
        },
        descr: {
            type: String
        },
        types: {
            type: Array,
            default: () => ([])
        }
    },
    computed: {
        itemsComputed() {
            return this.items
        }
    },
    methods: {
        addWithTypes() {
            if (Object.keys(this.items.buffer).length) {
                this.items.value.push({
                    type: {
                        name: this.items.buffer.name,
                        value: this.items.buffer.value
                    },
                    descr: this.items.bufferDescr
                }),
                this.items.buffer = {},
                this.$refs.Input.value = ''
            }

        },
        addWithoutTypes() {
            this.items.value.push({
                descr: this.items.bufferDescr
            }),
            this.items.bufferDescr = '',
            this.$refs.Input.value = ''
        }
    }
}
</script>